import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline'
import UnreadBadge from './UnreadBadge'

interface MessageButtonProps {
  onClick: () => void
  unreadCount?: number
  className?: string
  title?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
}

export default function MessageButton({
  onClick,
  unreadCount = 0,
  className = '',
  title = 'Messages',
  size = 'md',
}: MessageButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`relative p-2 text-gray-600 hover:text-gray-900 transition-colors ${className}`}
      title={title}
    >
      <ChatBubbleLeftIcon className={sizeClasses[size]} />
      {unreadCount > 0 && <UnreadBadge count={unreadCount} className="absolute -top-1 -right-1" />}
    </button>
  )
}
